module.exports = __webpack_public_path__ + "static/media/ViolinScore2-KELsMUSIC.49fec605.jpg";